import { useState, useEffect, useCallback } from 'react';
import { Table, Button, Modal, Input, Select } from '../../components/ui';
import ImagePickerField from '../../components/ui/ImagePickerField';
import { apiFetch } from '../../services/api';

const BG_STYLES = [
  { value:'guilloche', label:'Guilloche'    },{ value:'mosaic',   label:'Mosaic'      },
  { value:'rope',      label:'Rope Border'  },{ value:'radiant',  label:'Radiant'     },
  { value:'jewel',     label:'Jewel Panels' },{ value:'wave',     label:'Wave Lattice'},
  { value:'arch',      label:'Gothic Arch'  },
];

const TITLE_PRESETS = [
  'Certificate of Completion','Certificate of Excellence','Certificate of Participation',
  'Certificate of Achievement','Professional Certificate','Certificate of Internship','Certificate of Attendance',
];

const COLOR_PRESETS = [
  {label:'Gold',  value:'#e8a43a'},{label:'Green', value:'#3ecf8e'},{label:'Blue',   value:'#4e9cf5'},
  {label:'Purple',value:'#a78bfa'},{label:'Pink',  value:'#f472b6'},{label:'Teal',   value:'#2dd4bf'},
  {label:'Red',   value:'#f06060'},
];

const PROGRAM_TYPES = [
  {value:'',             label:'All / Default'  },{value:'bootcamp',     label:'Bootcamp'     },
  {value:'workshop',     label:'Workshop'       },{value:'certification',label:'Certification'},
  {value:'course',       label:'Course'         },{value:'mentorship',   label:'Mentorship'   },
  {value:'internship',   label:'Internship'     },
];

const DUMMY = {
  recipient_name:'Sample Recipient', recipient_email:'recipient@example.com',
  program_title:'Advanced Technology Bootcamp', cohort_name:'Cohort 2025-A',
  cert_hash:'abc123def456abc123def456abc123def456abc123def456abc123def456ab12',
  issued_at: new Date().toISOString(), start_date:'2025-01-06', end_date:'2025-03-28',
};

// Build simple pattern path data for preview
function getPatternPaths(style, c) {
  const s = style.replace(/-light$/,'').replace(/-dark$/,'');
  if (s==='guilloche') return (
    <g>
      {Array.from({length:30},(_,i)=>{const y=i*21;return(
        <g key={i}>
          <path d={`M0,${y} Q225,${y-26} 450,${y} Q675,${y+26} 900,${y}`} fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" opacity="0.8"/>
          <path d={`M0,${y-10} Q225,${y+16} 450,${y-10} Q675,${y-36} 900,${y-10}`} fill="none" stroke={c} strokeWidth="0.8" strokeLinecap="round" opacity="0.45"/>
        </g>
      );})}
      <rect x="14" y="10" width="872" height="578" rx="4" fill="none" stroke={c} strokeWidth="2.5" opacity="0.8"/>
      {[[14,10],[886,10],[14,588],[886,588]].map(([px,py],i)=>(
        <g key={i}><line x1={px} y1={py} x2={px+(i%2===0?28:-28)} y2={py} stroke={c} strokeWidth="3" opacity="0.9"/><line x1={px} y1={py} x2={px} y2={py+(i<2?28:-28)} stroke={c} strokeWidth="3" opacity="0.9"/></g>
      ))}
    </g>
  );
  if (s==='mosaic'||s==='jewel') return (
    <g>
      {[0,1,2,3,4].map(row=>[0,1,2,3,4,5,6].map(col=>{
        const x=col*115+(row%2)*57, y=row*100-50;
        const fills=['#1a0a0260','#0a1a0860','#0a081860','#180a0a60','#08180a60','#10081060'];
        const lFills=['#f5e6c060','#d4ecd460','#d4d4f060','#f0d4d460','#d4ead460','#f0d8c060'];
        const isLt = style.endsWith('-light');
        return <polygon key={`${row}-${col}`}
          points={`${x+57},${y} ${x+115},${y+33} ${x+115},${y+100} ${x+57},${y+133} ${x},${y+100} ${x},${y+33}`}
          fill={isLt?lFills[(row+col)%6]:fills[(row+col)%6]} stroke={c} strokeWidth="1.8" opacity="0.9"/>;
      }))}
      <rect x="14" y="10" width="872" height="578" rx="4" fill="none" stroke={c} strokeWidth="2" opacity="0.7"/>
    </g>
  );
  if (s==='radiant') return (
    <g>
      {Array.from({length:36},(_,i)=>{const a=i*10*Math.PI/180;return <line key={i} x1="450" y1="298" x2={450+Math.cos(a)*700} y2={298+Math.sin(a)*700} stroke={c} strokeWidth="0.9" opacity="0.5"/>;  })}
      {[70,140,210,280,350].map(r=><polygon key={r} stroke={c} strokeWidth={r<140?2:1} fill={r===70?`${c}25`:'none'} points={Array.from({length:6},(_,i)=>{const a=i*60*Math.PI/180-Math.PI/6;return `${450+r*Math.cos(a)},${298+r*Math.sin(a)}`;}).join(' ')} opacity={r===70?1:0.6}/>)}
      {Array.from({length:6},(_,i)=>{const a=i*60*Math.PI/180;return <line key={i} x1={450+140*Math.cos(a)} y1={298+140*Math.sin(a)} x2={450+210*Math.cos(a)} y2={298+210*Math.sin(a)} stroke={c} strokeWidth="2" opacity="0.7"/>;  })}
      <rect x="14" y="10" width="872" height="578" rx="4" fill="none" stroke={c} strokeWidth="2" opacity="0.6"/>
    </g>
  );
  if (s==='arch') return (
    <g>
      {[65,130,195,260,325,390,455,520,585,650,715,780,845].map(x=>(
        <path key={x} d={`M${x-30},598 Q${x-30},460 ${x-30},382 Q${x-30},322 ${x},298 Q${x+30},322 ${x+30},382 L${x+30},598`} fill="none" stroke={c} strokeWidth="1.2" opacity="0.65"/>
      ))}
      {[400,450,490,530,568].map(y=><line key={y} x1="0" y1={y} x2="900" y2={y} stroke={c} strokeWidth="0.6" opacity="0.4"/>)}
      {Array.from({length:12},(_,i)=>{const a=i*30*Math.PI/180,rx=450+65*Math.cos(a),ry=165+65*Math.sin(a);return <ellipse key={i} cx={rx} cy={ry} rx={14} ry={28} fill={`${c}18`} stroke={c} strokeWidth="1" opacity="0.8" transform={`rotate(${i*30} ${rx} ${ry})`}/>;  })}
      <circle cx="450" cy="165" r="80" fill="none" stroke={c} strokeWidth="2" opacity="0.7"/>
      <circle cx="450" cy="165" r="60" fill={`${c}12`} stroke={c} strokeWidth="1" opacity="0.5"/>
      <rect x="14" y="10" width="872" height="578" rx="4" fill="none" stroke={c} strokeWidth="2" opacity="0.6"/>
    </g>
  );
  if (s==='wave') return (
    <g>
      {Array.from({length:30},(_,i)=>{const y=i*21;return <path key={i} d={`M0,${y} C150,${y-20} 300,${y+20} 450,${y} S750,${y-20} 900,${y}`} fill="none" stroke={c} strokeWidth={i%3===0?1.6:0.8} strokeLinecap="round" opacity={i%3===0?0.75:0.45}/>;  })}
      {Array.from({length:16},(_,col)=>{const x=col*58,y=0;return <polygon key={col} points={`${x+29},${y} ${x+58},${y+17} ${x+58},${y+52} ${x+29},${y+69} ${x},${y+52} ${x},${y+17}`} fill="none" stroke={c} strokeWidth="1" opacity="0.55"/>;  })}
      <path d="M50,14 Q450,3 850,14" fill="none" stroke={c} strokeWidth="2" opacity="0.75"/>
      <path d="M50,584 Q450,595 850,584" fill="none" stroke={c} strokeWidth="2" opacity="0.75"/>
      <path d="M20,18 Q12,298 20,580" fill="none" stroke={c} strokeWidth="2" opacity="0.75"/>
      <path d="M880,18 Q888,298 880,580" fill="none" stroke={c} strokeWidth="2" opacity="0.75"/>
      <path d="M20,18 Q30,8 44,18 Q56,28 44,38" fill="none" stroke={c} strokeWidth="1.8" opacity="0.8"/>
      <path d="M880,18 Q870,8 856,18 Q844,28 856,38" fill="none" stroke={c} strokeWidth="1.8" opacity="0.8"/>
      <path d="M20,580 Q30,590 44,580 Q56,570 44,560" fill="none" stroke={c} strokeWidth="1.8" opacity="0.8"/>
      <path d="M880,580 Q870,590 856,580 Q844,570 856,560" fill="none" stroke={c} strokeWidth="1.8" opacity="0.8"/>
    </g>
  );
  // rope
  return (
    <g>
      {Array.from({length:18},(_,i)=><line key={i} x1={i*52-200} y1="0" x2={i*52+598} y2="598" stroke={c} strokeWidth="0.8" opacity="0.3"/>)}
      <path d="M0,34 Q56,22 112,34 Q168,46 224,34 Q280,22 336,34 Q392,46 448,34 Q504,22 560,34 Q616,46 672,34 Q728,22 784,34 Q840,46 900,34" fill="none" stroke={c} strokeWidth="6" strokeLinecap="round" opacity="1"/>
      <path d="M0,44 Q56,56 112,44 Q168,32 224,44 Q280,56 336,44 Q392,32 448,44 Q504,56 560,44 Q616,32 672,44 Q728,56 784,44 Q840,32 900,44" fill="none" stroke={c} strokeWidth="3.5" strokeLinecap="round" opacity="0.7"/>
      <path d="M0,564 Q56,552 112,564 Q168,576 224,564 Q280,552 336,564 Q392,576 448,564 Q504,552 560,564 Q616,576 672,564 Q728,552 784,564 Q840,576 900,564" fill="none" stroke={c} strokeWidth="6" strokeLinecap="round" opacity="1"/>
      <path d="M0,574 Q56,586 112,574 Q168,562 224,574 Q280,586 336,574 Q392,562 448,574 Q504,586 560,574 Q616,562 672,574 Q728,586 784,574 Q840,562 900,574" fill="none" stroke={c} strokeWidth="3.5" strokeLinecap="round" opacity="0.7"/>
      <path d="M36,42 Q30,100 36,158 Q42,216 36,274 Q30,332 36,390 Q42,448 36,506 Q30,556 36,572" fill="none" stroke={c} strokeWidth="6" strokeLinecap="round" opacity="1"/>
      <path d="M46,42 Q52,100 46,158 Q40,216 46,274 Q52,332 46,390 Q40,448 46,506 Q52,556 46,572" fill="none" stroke={c} strokeWidth="3.5" strokeLinecap="round" opacity="0.7"/>
      <path d="M864,42 Q858,100 864,158 Q870,216 864,274 Q858,332 864,390 Q870,448 864,506 Q858,556 864,572" fill="none" stroke={c} strokeWidth="6" strokeLinecap="round" opacity="1"/>
      <path d="M874,42 Q880,100 874,158 Q868,216 874,274 Q880,332 874,390 Q868,448 874,506 Q880,556 874,572" fill="none" stroke={c} strokeWidth="3.5" strokeLinecap="round" opacity="0.7"/>
      {[[36,36],[864,36],[36,572],[864,572]].map(([rx,ry],i)=>(
        <g key={i} transform={`translate(${rx},${ry})`}><circle r="15" fill={c} opacity="0.8"/><circle r="9" fill="rgba(0,0,0,0.6)"/><circle r="4.5" fill={c} opacity="0.9"/></g>
      ))}
      <rect x="60" y="56" width="780" height="488" rx="3" fill="none" stroke={c} strokeWidth="1" opacity="0.4"/>
    </g>
  );
}

export default function CertificateTemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [modal, setModal]         = useState(null);
  const [selected, setSel]        = useState(null);
  const [saving, setSaving]       = useState(false);
  const [preview, setPreview]     = useState(null);
  const [form, setForm]           = useState({});

  const token   = localStorage.getItem('mh_token');
  const headers = { 'Content-Type':'application/json', Authorization:`Bearer ${token}` };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiFetch('/admin/certificate-templates', { headers });
      setTemplates((await res.json()).data || []);
    } catch { setTemplates([]); } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const emptyForm = () => ({
    name:'', slug:'', title_text:'Certificate of Completion',
    body_text:'has successfully completed the program',
    signatory_name:'MilleHills Ltd', signatory_title:'Issuing Authority',
    signatory_person:'', signatory_name2:'', signatory_title2:'', signatory_person2:'',
    signature_url:'', logo_url:'', primary_color:'#e8a43a',
    background_style:'guilloche', program_type:'', is_default:false, description:'',
  });

  const openCreate = () => { setForm(emptyForm()); setSel(null); setModal('edit'); };
  const openEdit   = t => {
    setForm({
      name:t.name, slug:t.slug,
      title_text:t.title_text||'Certificate of Completion',
      body_text:t.body_text||'has successfully completed the program',
      signatory_name:t.signatory_name||'MilleHills Ltd',
      signatory_title:t.signatory_title||'Issuing Authority',
      signatory_person:t.signatory_person||'',
      signatory_name2:t.signatory_name2||'', signatory_title2:t.signatory_title2||'',
      signatory_person2:t.signatory_person2||'',
      signature_url:t.signature_url||'', logo_url:t.logo_url||'',
      primary_color:t.primary_color||'#e8a43a',
      background_style:t.background_style||'guilloche',
      program_type:t.program_type||'', is_default:t.is_default||false, description:t.description||'',
    });
    setSel(t); setModal('edit');
  };

  const bp = f => ({ ...DUMMY, primary_color:f.primary_color||'#e8a43a', title_text:f.title_text||'Certificate of Completion', body_text:f.body_text||'has successfully completed the program', signatory_name:f.signatory_name||'MilleHills Ltd', signatory_title:f.signatory_title||'Issuing Authority', signatory_person:f.signatory_person||'', signatory_name2:f.signatory_name2||'', signatory_title2:f.signatory_title2||'', signatory_person2:f.signatory_person2||'', signature_url:f.signature_url||null, logo_url:f.logo_url||null, background_style:f.background_style||'guilloche', program_type:f.program_type||'' });

  const handleSave = async () => {
    setSaving(true);
    try {
      if (!selected) await apiFetch('/admin/certificate-templates',{ method:'POST', headers, body:JSON.stringify(form) });
      else           await apiFetch(`/admin/certificate-templates/${selected.id}`,{ method:'PUT', headers, body:JSON.stringify(form) });
      setModal(null); load();
    } catch { alert('Save failed'); } finally { setSaving(false); }
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete this template?')) return;
    try {
      const res = await apiFetch(`/admin/certificate-templates/${id}`,{ method:'DELETE', headers });
      const data = await res.json();
      if (!res.ok) alert(data.error||'Delete failed'); else load();
    } catch { alert('Delete failed'); }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]:v }));

  const COLS = [
    { key:'name', label:'Template', render:(v,row) => (
      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
        <div style={{ width:28, height:28, borderRadius:6, background:`${row.primary_color||'#e8a43a'}22`, border:`2px solid ${row.primary_color||'#e8a43a'}`, flexShrink:0 }}/>
        <div><div style={{ fontWeight:600 }}>{v}</div><div style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'monospace' }}>{row.slug}</div></div>
      </div>
    )},
    { key:'title_text',       label:'Title',      render:v => <span style={{ fontSize:12, color:'var(--text-secondary)' }}>{v}</span> },
    { key:'background_style', label:'Background', render:v => <span style={{ fontSize:11, color:'var(--accent)', textTransform:'capitalize' }}>{v||'guilloche'}</span> },
    { key:'program_type',     label:'Applies To', render:v => <span style={{ fontSize:11, color:v?'var(--green-light)':'var(--text-muted)', textTransform:'capitalize' }}>{v||'All programs'}</span> },
    { key:'usage_count',      label:'Used',       render:v => <span style={{ fontFamily:'var(--font-display)', fontWeight:600, color:'var(--accent)' }}>{v||0}</span> },
    { key:'is_default',       label:'Default',    render:v => v ? <span style={{ color:'var(--green-light)', fontWeight:700, fontSize:12 }}>✓ Default</span> : '—' },
    { key:'_actions',         label:'',           render:(_,row) => (
      <div style={{ display:'flex', gap:6 }} onClick={e=>e.stopPropagation()}>
        <Button variant="ghost" size="sm" onClick={()=>setPreview(bp(row))}>Preview</Button>
        <Button variant="ghost" size="sm" onClick={()=>openEdit(row)}>Edit</Button>
        {!row.is_default && <Button variant="ghost" size="sm" style={{ color:'var(--red-light)' }} onClick={()=>handleDelete(row.id)}>Del</Button>}
      </div>
    )},
  ];

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:24 }}>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:14, fontWeight:600, marginBottom:2 }}>Certificate Templates</div>
          <div style={{ fontSize:12, color:'var(--text-muted)' }}>Settings snapshotted on issuance — edits never affect past certificates.</div>
        </div>
        <Button onClick={openCreate}>+ New Template</Button>
      </div>

      <div style={{ background:'var(--bg-surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', overflow:'hidden' }}>
        <Table columns={COLS} data={templates} loading={loading} onRowClick={openEdit}/>
      </div>

      {/* ── Edit Modal ── */}
      <Modal open={modal==='edit'} onClose={()=>setModal(null)}
        title={selected?`Edit — ${selected.name}`:'New Certificate Template'} width={740}>
        <div style={{ display:'flex', flexDirection:'column', gap:20 }}>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
            <Input label="Template Name" value={form.name||''} onChange={e=>{ const slug=e.target.value.toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,''); set('name',e.target.value); set('slug',slug); }}/>
            <Input label="Slug" value={form.slug||''} onChange={e=>set('slug',e.target.value)} style={{ fontFamily:'monospace' }}/>
          </div>

          <div>
            <label style={L}>Certificate Title</label>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:8 }}>
              {TITLE_PRESETS.map(p=>(
                <button key={p} onClick={()=>set('title_text',p)} style={{ fontSize:11, padding:'4px 10px', borderRadius:20, cursor:'pointer', background:form.title_text===p?'var(--accent-muted)':'var(--bg-elevated)', border:`1px solid ${form.title_text===p?'var(--accent)':'var(--border)'}`, color:form.title_text===p?'var(--accent)':'var(--text-secondary)', transition:'all 0.15s' }}>{p}</button>
              ))}
            </div>
            <input value={form.title_text||''} onChange={e=>set('title_text',e.target.value)} style={inputStyle}/>
          </div>

          <div>
            <label style={L}>Body Statement</label>
            <input value={form.body_text||''} onChange={e=>set('body_text',e.target.value)} style={inputStyle}/>
            <div style={{ fontSize:11, color:'var(--text-muted)', marginTop:4 }}>
              Preview: <em style={{ color:'var(--text-secondary)' }}>"[Name] {form.body_text||'…'} [Program]"</em>
            </div>
          </div>

          {/* Signatories */}
          <div style={{ padding:'16px', background:'var(--bg-elevated)', border:'1px solid var(--border)', borderRadius:8 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'var(--text-secondary)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:14 }}>
              Signatories
            </div>

            {/* Primary signatory */}
            <div style={{ marginBottom:14 }}>
              <div style={{ fontSize:11, color:'var(--accent)', fontWeight:600, marginBottom:10 }}>Primary Signatory (left)</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <Input label="Person's Full Name" value={form.signatory_person||''} onChange={e=>set('signatory_person',e.target.value)} placeholder="e.g. Jean-Paul Uwimana"/>
                <Input label="Title / Position" value={form.signatory_title||''} onChange={e=>set('signatory_title',e.target.value)} placeholder="e.g. Executive Director"/>
                <div style={{ gridColumn:'1/-1' }}>
                  <Input label="Organisation" value={form.signatory_name||''} onChange={e=>set('signatory_name',e.target.value)} placeholder="e.g. MilleHills Ltd"/>
                </div>
              </div>
            </div>

            <div style={{ height:1, background:'var(--border)', marginBottom:14 }}/>

            {/* Second signatory */}
            <div>
              <div style={{ fontSize:11, color:'var(--text-muted)', fontWeight:600, marginBottom:10 }}>Second Signatory (right) — optional</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <Input label="Person's Full Name" value={form.signatory_person2||''} onChange={e=>set('signatory_person2',e.target.value)} placeholder="e.g. Alice Mukamana"/>
                <Input label="Title / Position" value={form.signatory_title2||''} onChange={e=>set('signatory_title2',e.target.value)} placeholder="e.g. Programme Director"/>
                <div style={{ gridColumn:'1/-1' }}>
                  <Input label="Organisation" value={form.signatory_name2||''} onChange={e=>set('signatory_name2',e.target.value)} placeholder="e.g. Rwanda ICT Chamber"/>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding:'14px 16px', background:'rgba(232,164,58,0.06)', border:'1px solid rgba(232,164,58,0.2)', borderRadius:8 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'var(--accent)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:6 }}>◈ Logo</div>
            <p style={{ fontSize:11, color:'var(--text-muted)', marginBottom:10, lineHeight:1.5 }}>
              Appears in the header, centered as a large watermark on the certificate background, in the seal, and embedded in the QR code.
            </p>
            <ImagePickerField label="Select from Media Library" value={form.logo_url||''} onChange={url=>set('logo_url',url)}/>
          </div>

          <ImagePickerField label="Signature Image (optional)" value={form.signature_url||''} onChange={url=>set('signature_url',url)}/>

          <div>
            <label style={L}>Background Pattern</label>
            <p style={{ fontSize:11, color:'var(--text-muted)', marginBottom:10, lineHeight:1.5 }}>
              Fills the entire certificate as a watermark. Append <strong>-light</strong> for cream/parchment background.
            </p>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:6, marginBottom:10 }}>
              {BG_STYLES.flatMap(bg=>[
                { value:bg.value,           mode:'◐ Dark',  bg:'#0d0f12', accent:'#e8a43a' },
                { value:`${bg.value}-light`,mode:'◑ Light', bg:'#faf7f0', accent:'#c8841a' },
              ]).map(opt=>(
                <div key={opt.value} onClick={()=>set('background_style',opt.value)}
                  style={{ padding:'7px 5px', borderRadius:6, border:`2px solid ${form.background_style===opt.value?'var(--accent)':'var(--border)'}`, background:form.background_style===opt.value?'var(--accent-muted)':'var(--bg-elevated)', cursor:'pointer', transition:'all 0.15s', textAlign:'center' }}>
                  <div style={{ width:'100%', height:16, borderRadius:3, background:opt.bg, border:`1px solid ${opt.accent}33`, marginBottom:4 }}/>
                  <div style={{ fontSize:9, fontWeight:600, color:form.background_style===opt.value?'var(--accent)':'var(--text-secondary)', lineHeight:1.3 }}>{opt.value.replace(/-light$/,' ☀')}</div>
                  <div style={{ fontSize:8, color:'var(--text-muted)' }}>{opt.mode}</div>
                </div>
              ))}
            </div>
            <div style={{ padding:'10px 14px', background:'var(--bg-elevated)', borderRadius:8, border:'1px solid var(--border)', display:'flex', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:11, color:'var(--text-muted)', flexShrink:0 }}>Selected:</span>
              <span style={{ padding:'4px 12px', borderRadius:20, background:`${form.primary_color||'#e8a43a'}18`, border:`1px solid ${form.primary_color||'#e8a43a'}44`, fontSize:11, color:form.primary_color||'#e8a43a', fontWeight:600 }}>{form.background_style||'guilloche'}</span>
              <button onClick={()=>setPreview(bp(form))} style={{ marginLeft:'auto', padding:'6px 14px', borderRadius:6, background:'var(--accent)', color:'#0d0f12', border:'none', cursor:'pointer', fontSize:12, fontWeight:600 }}>Live Preview →</button>
            </div>
          </div>

          <div>
            <label style={L}>Primary Colour</label>
            <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
              {COLOR_PRESETS.map(c=>(
                <button key={c.value} onClick={()=>set('primary_color',c.value)} title={c.label}
                  style={{ width:32, height:32, borderRadius:8, background:c.value, border:`3px solid ${form.primary_color===c.value?'#fff':'transparent'}`, cursor:'pointer', outline:form.primary_color===c.value?`2px solid ${c.value}`:'none', transition:'all 0.15s' }}/>
              ))}
              <div style={{ display:'flex', alignItems:'center', gap:8, marginLeft:8 }}>
                <input type="color" value={form.primary_color||'#e8a43a'} onChange={e=>set('primary_color',e.target.value)} style={{ width:36, height:36, borderRadius:8, border:'1px solid var(--border)', cursor:'pointer' }}/>
                <input value={form.primary_color||''} onChange={e=>set('primary_color',e.target.value)} style={{ width:90, background:'var(--bg-elevated)', border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', color:'var(--text-primary)', padding:'7px 10px', fontSize:13, fontFamily:'monospace' }}/>
              </div>
            </div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
            <Select label="Auto-apply to Program Type" value={form.program_type||''} onChange={e=>set('program_type',e.target.value)}>
              {PROGRAM_TYPES.map(t=><option key={t.value} value={t.value}>{t.label}</option>)}
            </Select>
            <div style={{ display:'flex', alignItems:'flex-end', paddingBottom:2 }}>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13 }}>
                <input type="checkbox" checked={form.is_default||false} onChange={e=>set('is_default',e.target.checked)}/>
                <span style={{ color:'var(--text-secondary)' }}>Set as default template</span>
              </label>
            </div>
          </div>

          <Input label="Internal Description" value={form.description||''} onChange={e=>set('description',e.target.value)} placeholder="e.g. Used for bootcamp graduates"/>

          <div style={{ display:'flex', gap:10, justifyContent:'flex-end', paddingTop:6 }}>
            <Button variant="secondary" onClick={()=>setModal(null)}>Cancel</Button>
            <Button onClick={handleSave} loading={saving}>{selected?'Save Changes':'Create Template'}</Button>
          </div>
        </div>
      </Modal>

      {/* ── PREVIEW MODAL ── */}
      {preview && (() => {
        const c       = preview.primary_color || '#e8a43a';
        const isLight = (preview.background_style||'').endsWith('-light');
        const bg      = isLight ? '#faf7f0' : '#0d0f12';
        const textClr = isLight ? '#1a1208'  : '#ffffff';
        const muted   = isLight ? 'rgba(30,18,4,0.45)'  : 'rgba(255,255,255,0.45)';
        const subtle  = isLight ? 'rgba(30,18,4,0.7)'   : 'rgba(255,255,255,0.7)';

        return (
          <div onClick={()=>setPreview(null)} style={{ position:'fixed', inset:0, zIndex:600, background:'rgba(0,0,0,0.92)', backdropFilter:'blur(12px)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:24, gap:14 }}>
            <div onClick={e=>e.stopPropagation()} style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:14 }}>

              <div style={{ display:'flex', justifyContent:'space-between', alignSelf:'stretch', alignItems:'center' }}>
                <span style={{ color:'rgba(255,255,255,0.4)', fontSize:13 }}>{preview.title_text} — Preview</span>
                <button onClick={()=>setPreview(null)} style={{ padding:'8px 14px', borderRadius:8, background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.15)', color:'#fff', cursor:'pointer', fontSize:13 }}>✕ Close</button>
              </div>

              {/* FULL WIDTH CERTIFICATE */}
              <div style={{ width:860, height:580, background:bg, position:'relative', overflow:'hidden', borderRadius:6, fontFamily:"'DM Sans',sans-serif", flexShrink:0 }}>

                {/* LAYER 1: Background pattern */}
                <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', pointerEvents:'none', zIndex:1 }}
                  viewBox="0 0 900 598" preserveAspectRatio="xMidYMid slice">
                  <g opacity="0.22">
                    {getPatternPaths(preview.background_style||'guilloche', c)}
                  </g>
                </svg>

                {/* LAYER 2: Logo centered watermark */}
                <div style={{ position:'absolute', inset:0, zIndex:2, display:'flex', alignItems:'center', justifyContent:'center', pointerEvents:'none' }}>
                  {preview.logo_url
                    ? <img src={preview.logo_url} alt="Watermark" style={{ width:180, height:180, objectFit:'contain', opacity:0.07 }}/>
                    : <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:230, color:c, opacity:0.06, lineHeight:1, userSelect:'none' }}>M</div>
                  }
                </div>

                {/* Top bar */}
                <div style={{ position:'absolute', top:0, left:0, right:0, height:4, background:c, zIndex:4 }}/>

                {/* Border frames */}
                <div style={{ position:'absolute', inset:13, border:`1.5px solid ${c}40`, borderRadius:4, pointerEvents:'none', zIndex:4 }}/>
                <div style={{ position:'absolute', inset:19, border:`0.5px solid ${c}15`, borderRadius:2, pointerEvents:'none', zIndex:4 }}/>

                {/* Corner ornaments */}
                {[{top:13,left:13},{top:13,right:13},{bottom:13,left:13},{bottom:13,right:13}].map((pos,i)=>(
                  <div key={i} style={{ position:'absolute', width:32, height:32, opacity:0.5, zIndex:5, ...pos }}>
                    <svg viewBox="0 0 32 32" fill="none">
                      <path fill={c} d={i===0?"M0 0 L32 0 L32 6 L6 6 L6 32 L0 32 Z":i===1?"M32 0 L0 0 L0 6 L26 6 L26 32 L32 32 Z":i===2?"M0 32 L32 32 L32 26 L6 26 L6 0 L0 0 Z":"M32 32 L0 32 L0 26 L26 26 L26 0 L32 0 Z"}/>
                    </svg>
                  </div>
                ))}

                {/* CONTENT */}
                <div style={{ position:'relative', zIndex:6, height:'100%', display:'flex', flexDirection:'column', padding:'20px 46px 16px' }}>

                  {/* Header */}
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8, flexShrink:0 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:9 }}>
                      {preview.logo_url
                        ? <img src={preview.logo_url} alt="Logo" style={{ height:36, objectFit:'contain' }}/>
                        : <div style={{ width:32, height:32, background:c, borderRadius:7, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:15, color:isLight?'#fff':'#0d0f12', fontFamily:"'Syne',sans-serif" }}>M</div>
                      }
                      <div>
                        <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:13, color:textClr }}>MilleHills</div>
                        <div style={{ fontSize:7, color:muted, letterSpacing:'0.12em', textTransform:'uppercase' }}>Gisenyi · Rwanda</div>
                      </div>
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ fontSize:7, fontWeight:700, letterSpacing:'0.18em', textTransform:'uppercase', color:c }}>{preview.title_text}</div>
                      <div style={{ fontSize:7, color:muted, fontFamily:'monospace', marginTop:1 }}>abc123def456…</div>
                    </div>
                  </div>
                  <div style={{ height:1, background:`linear-gradient(90deg,transparent,${c}55 20%,${c}55 80%,transparent)`, flexShrink:0 }}/>

                  {/* CENTER BLOCK */}
                  <div style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:10 }}>
                    <div style={{ textAlign:'center' }}>
                      <div style={{ fontSize:8, fontWeight:600, letterSpacing:'0.24em', textTransform:'uppercase', color:muted, marginBottom:6 }}>This is to certify that</div>
                      <div style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:800, color:c, lineHeight:1.1, marginBottom:3 }}>Sample Recipient Name</div>
                      <div style={{ fontSize:8, color:muted }}>recipient@example.com</div>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:12, width:'100%' }}>
                      <div style={{ flex:1, height:1, background:`linear-gradient(to right,transparent,${c}55)` }}/>
                      <span style={{ fontSize:13, color:c, opacity:0.85 }}>◈</span>
                      <div style={{ flex:1, height:1, background:`linear-gradient(to left,transparent,${c}55)` }}/>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:20, width:'100%', justifyContent:'center' }}>
                      <div style={{ textAlign:'center', flex:1, maxWidth:440 }}>
                        <div style={{ fontSize:11, color:subtle, lineHeight:1.7, marginBottom:5 }}>{preview.body_text}</div>
                        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:17, fontWeight:700, color:textClr, lineHeight:1.3, marginBottom:3 }}>Advanced Technology Bootcamp</div>
                        <div style={{ fontSize:8, color:muted }}>Cohort: 2025-A · Jan 2025 – Mar 2025</div>
                      </div>
                      <div style={{ width:1, height:65, background:`${c}25`, flexShrink:0 }}/>
                      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:6, flexShrink:0, width:80 }}>
                        <div style={{ position:'relative', width:56, height:56 }}>
                          <svg width="56" height="56" viewBox="0 0 56 56" style={{ position:'absolute', inset:0 }}>
                            <circle cx="28" cy="28" r="26" fill="none" stroke={c} strokeWidth="1" opacity="0.5" strokeDasharray="3 2.5"/>
                            <circle cx="28" cy="28" r="20" fill="none" stroke={c} strokeWidth="0.7" opacity="0.25"/>
                            {Array.from({length:8},(_,i)=>{const a=(i*45-90)*Math.PI/180;return<line key={i} x1={28+14*Math.cos(a)} y1={28+14*Math.sin(a)} x2={28+20*Math.cos(a)} y2={28+20*Math.sin(a)} stroke={c} strokeWidth="1.2" opacity="0.55"/>;})}
                          </svg>
                          <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
                            {preview.logo_url
                              ? <img src={preview.logo_url} alt="Logo" style={{ width:22, height:22, objectFit:'contain' }}/>
                              : <><div style={{ fontSize:13, color:c, fontFamily:"'Syne',sans-serif", fontWeight:800, lineHeight:1 }}>M</div><div style={{ fontSize:4, color:`${c}bb`, letterSpacing:'0.1em', textTransform:'uppercase' }}>MilleHills</div></>
                            }
                          </div>
                        </div>
                        <div style={{ width:40, height:40, background:'#fff', borderRadius:4, display:'flex', alignItems:'center', justifyContent:'center', padding:2 }}>
                          <svg width="36" height="36" viewBox="0 0 40 40">
                            <rect x="2" y="2" width="14" height="14" fill="none" stroke="#333" strokeWidth="1.5"/><rect x="5" y="5" width="8" height="8" fill="#333"/>
                            <rect x="24" y="2" width="14" height="14" fill="none" stroke="#333" strokeWidth="1.5"/><rect x="27" y="5" width="8" height="8" fill="#333"/>
                            <rect x="2" y="24" width="14" height="14" fill="none" stroke="#333" strokeWidth="1.5"/><rect x="5" y="27" width="8" height="8" fill="#333"/>
                            <rect x="24" y="24" width="4" height="4" fill="#333"/><rect x="30" y="24" width="4" height="4" fill="#333"/>
                            <rect x="36" y="24" width="4" height="4" fill="#333"/><rect x="24" y="30" width="4" height="4" fill="#333"/>
                            <rect x="30" y="36" width="4" height="4" fill="#333"/><rect x="36" y="36" width="4" height="4" fill="#333"/>
                          </svg>
                        </div>
                        <div style={{ fontSize:6, color:muted, letterSpacing:'0.08em', textTransform:'uppercase' }}>Scan to verify</div>
                      </div>
                    </div>
                  </div>

                  {/* Signatories — pinned bottom, centered */}
                  <div style={{ flexShrink:0 }}>
                    <div style={{ height:1, background:`${c}25`, marginBottom:9 }}/>
                    <div style={{ display:'flex', justifyContent:'center', alignItems:'flex-start', gap:50 }}>
                      <div style={{ textAlign:'center', minWidth:110 }}>
                        {preview.signature_url
                          ? <img src={preview.signature_url} alt="Sig" style={{ height:18, display:'block', margin:'0 auto 3px', opacity:0.85 }}/>
                          : <div style={{ width:96, height:1, background:`${c}55`, margin:'0 auto 4px' }}/>
                        }
                        {preview.signatory_person && <div style={{ fontSize:10, fontWeight:700, color:subtle, marginBottom:1 }}>{preview.signatory_person}</div>}
                        <div style={{ fontSize:9, fontWeight:preview.signatory_person?400:600, color:preview.signatory_person?muted:subtle }}>{preview.signatory_name}</div>
                        <div style={{ fontSize:7, color:muted, letterSpacing:'0.06em', textTransform:'uppercase', marginTop:1 }}>{preview.signatory_title}</div>
                      </div>
                      <div style={{ textAlign:'center', minWidth:110 }}>
                        <div style={{ width:96, height:1, background:`${c}55`, margin:'0 auto 4px' }}/>
                        <div style={{ fontSize:9, fontWeight:600, color:subtle }}>01 January 2025</div>
                        <div style={{ fontSize:7, color:muted, letterSpacing:'0.06em', textTransform:'uppercase', marginTop:1 }}>Date of Issue</div>
                      </div>
                      {(preview.signatory_name2||preview.signatory_person2) && (
                        <div style={{ textAlign:'center', minWidth:110 }}>
                          <div style={{ width:96, height:1, background:`${c}55`, margin:'0 auto 4px' }}/>
                          {preview.signatory_person2 && <div style={{ fontSize:10, fontWeight:700, color:subtle, marginBottom:1 }}>{preview.signatory_person2}</div>}
                          {preview.signatory_name2 && <div style={{ fontSize:9, fontWeight:preview.signatory_person2?400:600, color:preview.signatory_person2?muted:subtle }}>{preview.signatory_name2}</div>}
                          {preview.signatory_title2 && <div style={{ fontSize:7, color:muted, letterSpacing:'0.06em', textTransform:'uppercase', marginTop:1 }}>{preview.signatory_title2}</div>}
                        </div>
                      )}
                    </div>
                    <div style={{ marginTop:7, display:'flex', justifyContent:'space-between', fontSize:6, color:isLight?'rgba(30,18,4,0.18)':'rgba(255,255,255,0.16)' }}>
                      <span>Verify: millehills.rw/verify/abc123…</span>
                      <span>Founder-Led · Constitution-Protected · Gisenyi, Rwanda</span>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display:'flex', gap:16, fontSize:11, color:'rgba(255,255,255,0.35)' }}>
                <span>Background: <strong style={{ color:'rgba(255,255,255,0.6)' }}>{preview.background_style||'guilloche'}</strong></span>
                <span>Colour: <strong style={{ color:c }}>{c}</strong></span>
                <span>Type: <strong style={{ color:'rgba(255,255,255,0.6)' }}>{preview.program_type||'All programs'}</strong></span>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

const L = { fontSize:12, color:'var(--text-secondary)', fontWeight:500, textTransform:'uppercase', letterSpacing:'0.03em', display:'block', marginBottom:6 };
const inputStyle = { width:'100%', background:'var(--bg-elevated)', border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', color:'var(--text-primary)', padding:'8px 12px', fontSize:13, boxSizing:'border-box' };